import { render, staticRenderFns } from "./LoginUnhcrView.vue?vue&type=template&id=fed6546c&"
import script from "./LoginUnhcrView.vue?vue&type=script&lang=ts&"
export * from "./LoginUnhcrView.vue?vue&type=script&lang=ts&"
import style0 from "./LoginUnhcrView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports